import React from 'react'
import EshopCategory from './EshopCategory'

const EshopGrand = ({ products = [], eshopInfo = null }) => (
    <EshopCategory products={products} category="grand" eshopInfo={eshopInfo} />
)

export default EshopGrand